import { useQuery } from "@tanstack/react-query";
import { useGrowl } from "PFApp/use_growl";
import { Filters } from "PFTypes";

import { getProfileCalendars } from "../../../../../modules/admin/booking/services/api";
import { bookingConfigKeys } from "./query_keys";

type CalendarId = string | null;

export const useBookingConfigProfileCalendars = (
  calendarId?: CalendarId,
  filters?: Filters,
  page = 1,
  perPage = 25
) => {
  const growl = useGrowl();

  const handleError = (e) =>
    growl({
      message: e.responseJSON.errors[0].detail,
      kind: "error"
    });

  return useQuery({
    queryKey: bookingConfigKeys.profileCalendar(calendarId || "all", filters, page, perPage),
    queryFn: async () => getProfileCalendars(calendarId, filters, page, perPage),
    onError: handleError,
    keepPreviousData: true
  });
};
